import { Service } from "@models";
import { serviceService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class ServiceStore {
  services = new Map<string, Service>();
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (tenantId: number) => {
    this.setLoading(true);
    try {
      const services = await serviceService.getAll(tenantId);
      runInAction(() => {
        services.forEach((service: Service) => {
          this.services.set(service.id.toString(), service);
        });
        this.setLoading(false);
      });
    } catch (error) {
      console.error(error);
      this.setLoading(false);
    }
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  resetServices = () => {
    runInAction(() => {
      this.services.clear();
    });
  };
}
